/* es5-ext/number/to-integer */ function _(require, module, exports) {
    var sign = require(330) /* ../math/sign */, abs = Math.abs, floor = Math.floor;
    module.exports = function (value) {
        if (isNaN(value))
            return 0;
        value = Number(value);
        if ((value === 0) || !isFinite(value))
            return value;
        return sign(value) * floor(abs(value));
    };
}
